import script from "./TemplateText.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateText.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__